import React from "react";
// import { CountdownCircleTimer } from "react-countdown-circle-timer";

const SingleQuestionQuizScreen = ({
  question,
  handleUseranswer,
  submitQuiz,
  cancelQuiz,
  quizerror,
  submitquizbutton,
  currentquiztime,
  setCurrentquiztime,
  setShowQuizExitModal
}) => {
  return (
    <div className="d-flex justify-content-center quiz-screen">
      <div className="entry-screen text-align-center position-relative">
        {/* Beautiful Loader Overlay */}
        {submitquizbutton && (
          <div 
            className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center"
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              zIndex: 1000,
              borderRadius: '8px',
              backdropFilter: 'blur(3px)'
            }}
          >
            {/* Modern animated spinner with layered effect */}
            <div className="position-relative mb-4">
              <div className="spinner-border" style={{ 
                width: '4rem', 
                height: '4rem', 
                borderColor: '#0BA8CF',
                borderRightColor: 'transparent',
                borderWidth: '4px'
              }} role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              {/* Pulsing ring effect */}
              <div className="position-absolute top-50 start-50 translate-middle">
                <div className="spinner-border" style={{ 
                  width: '5rem', 
                  height: '5rem',
                  borderColor: '#0BA8CF',
                  borderRightColor: 'transparent',
                  borderWidth: '4px',
                  opacity: 0.25
                }}></div>
              </div>
            </div>
            
            {/* Elegant loading text */}
            <div className="loading-content">
              <p className="mb-2 fs-5 fw-bold" style={{ color: '#0BA8CF' }}>
                Submitting Your Answer...
              </p>
              <p className="mb-3 text-muted" style={{ fontSize: '0.9rem' }}>
                Please wait while we process your response
              </p>
              <div className="d-flex justify-content-center gap-2">
                <div className="rounded-circle" style={{ 
                  width: '10px', 
                  height: '10px', 
                  backgroundColor: '#0BA8CF',
                  animation: 'pulse 1.4s ease-in-out infinite both',
                  animationDelay: '-0.32s'
                }}></div>
                <div className="rounded-circle" style={{ 
                  width: '10px', 
                  height: '10px', 
                  backgroundColor: '#0BA8CF',
                  animation: 'pulse 1.4s ease-in-out infinite both',
                  animationDelay: '-0.16s'
                }}></div>
                <div className="rounded-circle" style={{ 
                  width: '10px', 
                  height: '10px', 
                  backgroundColor: '#0BA8CF',
                  animation: 'pulse 1.4s ease-in-out infinite both'
                }}></div>
              </div>
            </div>
          </div>
        )}

        {quizerror ? (
          <>
            <span className="text-danger alert-error">Select at least One Option</span>
            <br />
            <br />
          </>
        ) : (
          <></>
        )}
        <span className="question">{question.question}</span>
        <br />
        <div className="d-flex mt-4 justify-content-around options-row">
          {question.option_one ? (
            <>
              <input
                type="radio"
                className="d-none"
                id={question.option_one}
                name="topic_question"
                onChange={handleUseranswer}
                value="A"
                disabled={submitquizbutton}
              />
              <label 
                className="customTab" 
                htmlFor={question.option_one}
                style={{
                  opacity: submitquizbutton ? 0.6 : 1,
                  cursor: submitquizbutton ? 'not-allowed' : 'pointer',
                  pointerEvents: submitquizbutton ? 'none' : 'auto'
                }}
              >
                {question.option_one}
              </label>
            </>
          ) : null}
          {question.option_two ? (
            <>
              <input
                type="radio"
                className="d-none"
                id={question.option_two}
                name="topic_question"
                onChange={handleUseranswer}
                value="B"
                disabled={submitquizbutton}
              />
              <label 
                className="customTab" 
                htmlFor={question.option_two}
                style={{
                  opacity: submitquizbutton ? 0.6 : 1,
                  cursor: submitquizbutton ? 'not-allowed' : 'pointer',
                  pointerEvents: submitquizbutton ? 'none' : 'auto'
                }}
              >
                {question.option_two}
              </label>
            </>
          ) : null}
        </div>
        <div className="mt-4 d-flex justify-content-around options-row">
          {question.option_three ? (
            <>
              <input
                type="radio"
                className="d-none"
                id={question.option_three}
                name="topic_question"
                onChange={handleUseranswer}
                value="C"
                disabled={submitquizbutton}
              />
              <label 
                className="customTab" 
                htmlFor={question.option_three}
                style={{
                  opacity: submitquizbutton ? 0.6 : 1,
                  cursor: submitquizbutton ? 'not-allowed' : 'pointer',
                  pointerEvents: submitquizbutton ? 'none' : 'auto'
                }}
              >
                {question.option_three}
              </label>
            </>
          ) : null}
          {question.option_four ? (
            <>
              <input
                type="radio"
                className="d-none"
                id={question.option_four}
                name="topic_question"
                onChange={handleUseranswer}
                value="D"
                disabled={submitquizbutton}
              />
              <label 
                className="customTab" 
                htmlFor={question.option_four}
                style={{
                  opacity: submitquizbutton ? 0.6 : 1,
                  cursor: submitquizbutton ? 'not-allowed' : 'pointer',
                  pointerEvents: submitquizbutton ? 'none' : 'auto'
                }}
              >
                {question.option_four}
              </label>
            </>
          ) : null}
        </div>

        <div className="container mt-4 quiz-timer">
          <div className="row mt-3">
            <div className="col-lg-2 mt-4">
              <button 
                onClick={() => setShowQuizExitModal(true)}
                className="btn btn-secondary-s mb-3 btn-lg w-90 text-white"
                disabled={submitquizbutton}
                style={{
                  opacity: submitquizbutton ? 0.6 : 1,
                  cursor: submitquizbutton ? 'not-allowed' : 'pointer'
                }}
              >
                <i className="fa fa-arrow-left fs-12"></i> Exit
              </button>
            </div>
            <div className="col-lg-8 col-md-6 mt-4">
              <div className="d-flex justify-content-between gap-4 mb-4">
                <button
                  disabled={submitquizbutton}
                  className="btn btn-primary-s text-white btn-lg w-100 rounded-2"
                  onClick={submitQuiz}
                >
                  {submitquizbutton ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Submitting...
                    </>
                  ) : (
                    'Submit'
                  )}
                </button>
              </div>
            </div>
            {/*
            <div className="col-2">
              <CountdownCircleTimer
                isPlaying
                isGrowing={true}
                duration={180}
                size={100}
                initialRemainingTime={180}
                colors="#0BA8CF"
                onUpdate={(remainingTime) => {
                  setCurrentquiztime(remainingTime);
                  if (remainingTime === 0) {
                    cancelQuiz();
                  }
                }}
              >
                {({ remainingTime }) => {
                  const minutes = Math.floor(currentquiztime / 60);
                  const seconds = currentquiztime % 60;
                  const formattedMinutes = String(minutes).padStart(2, '0');
                  const formattedSeconds = String(seconds).padStart(2, '0');
                  return `${formattedMinutes}:${formattedSeconds}`;
                }}
              </CountdownCircleTimer>
            </div>
            */}
          </div>
        </div>

        {/* CSS Animation */}
        <style dangerouslySetInnerHTML={{
          __html: `
            @keyframes pulse {
              0%, 80%, 100% {
                transform: scale(0.8);
                opacity: 0.5;
              }
              40% {
                transform: scale(1.2);
                opacity: 1;
              }
            }
            
            .spinner-border {
              animation: spin 1s linear infinite;
            }
            
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }

            @media (max-width: 767.98px) {
              .quiz-screen {
                font-size: 1rem;
              }
              .quiz-screen .entry-screen {
                padding: 1.25rem;
              }
              .quiz-screen .question {
                font-size: 1.15rem;
                margin-bottom: 0.75rem;
              }
              .quiz-screen .options-row {
                flex-direction: column;
                align-items: stretch;
              }
              .quiz-screen .customTab {
                font-size: 1rem;
                padding: 0.35rem 0.55rem;
                margin: 0.5rem 0;
                width: 100%;
                text-align: left;
              }
              .quiz-screen .btn {
                padding: 0.4rem 0.6rem;
                font-size: 1rem;
              }
              .quiz-screen .mt-4 {
                margin-top: 0.85rem !important;
              }
              .quiz-screen .container.mt-4 {
                margin-top: 0.9rem !important;
              }
            }
          `
        }} />
      </div>
    </div>
  );
};

export default SingleQuestionQuizScreen;
